import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAlerta } from "utils/alertas";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/user-profile/Header";

import AuthService from "../../services/auth-service";
import { TextField } from "@mui/material";

const UserProfile = () => {
  const [isDemo, setIsDemo] = useState(false);
  const [notification, setNotification] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { mostrarAlerta } = useAlerta();
  const [user, setUser] = useState({
    name: "",
    apellido_paterno: "",
    apellido_materno: "",
    ci: "",
    expedido: "",
    telefono_fijo: "",
    celular: "",
    fecha_cumpleaños: "",
    username: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });
  const togglePassword = () => setShowPassword(!showPassword);
  const toggleConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);
  const [errors, setErrors] = useState({
    nameError: false,
    emailError: false,
    newPassError: false,
    confirmPassError: false,
  });

  const getUserData = async () => {
    try {
      const storedUser = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("access_token");

      if (!storedUser) {
        console.error("No hay usuario en sessionStorage");
        return;
      }

      const { id } = JSON.parse(storedUser);

      // 🔥 consumir API usando el ID
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/usuarios/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al obtener usuario");
      }

      const data = await response.json();

      // 🔥 solo actualizar estado (NO sessionStorage)
      setUser((prev) => ({
        ...prev,
        ...data,
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      }));

      // opcional demo
      if (data.id === 1) {
        setIsDemo(process.env.REACT_APP_IS_DEMO === "true");
      }

    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (notification === true) {
      setTimeout(() => {
        setNotification(false);
      }, 5000);
    }
  }, [notification]);

  const changeHandler = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      const storedUser = sessionStorage.getItem("user");
      const token = sessionStorage.getItem("access_token");

      const { id } = JSON.parse(storedUser);

      // 🔥 VALIDACIONES (las tuyas están bien)
      if (user.name.trim() === "") {
        setErrors({ ...errors, nameError: true });
        return;
      }

      // 🔥 BODY REAL (AQUÍ ESTÁ LA CLAVE)
      const body = {
        name: user.name,
        apellido_paterno: user.apellido_paterno,
        apellido_materno: user.apellido_materno,
        ci: user.ci,
        username: user.username,
        fecha_cumpleaños: user.fecha_cumpleaños,
        telefono_fijo: user.telefono_fijo,
        celular: user.celular,
        expedido: user.expedido,
        email: user.email,
        rol: user.rol,
      };

      const newPass = user.newPassword.trim();
      const confirmPass = user.confirmPassword.trim();
      if (newPass !== "") {
        const confirmar = window.confirm("¿Estás seguro de cambiar tu contraseña?");
        if (!confirmar) return;

        if (newPass.length < 6) {
          setErrors({ ...errors, newPassError: true });
          return;
        }

        if (newPass !== confirmPass) {
          setErrors({ ...errors, confirmPassError: true });
          return;
        }

        body.password = newPass;
        body.password_confirmation = confirmPass;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/${id}`,
        {
          method: "PUT", // 🔥 IMPORTANTE
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.log("ERROR BACK:", errorData);
        throw new Error("Error al actualizar");
      }

      const data = await response.json();

      mostrarAlerta("Perfil actualizado correctamente","success");

      setNotification(true);

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header user={user}>
        <MDBox
          component="form"
          onSubmit={submitHandler}
          display="flex"
          flexDirection="column"
          gap={3}
          mt={4}
        >

          {/* =========================
              DATOS PERSONALES
          ========================== */}
          <MDTypography variant="h6">Datos Personales</MDTypography>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="Nombre"
              name="name"
              value={user.name}
              onChange={changeHandler}
              error={errors.nameError}
            />

            <MDInput
              fullWidth
              label="Email"
              name="email"
              value={user.email}
              onChange={changeHandler}
              error={errors.emailError}
              disabled={isDemo}
            />
          </MDBox>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="Apellido Paterno"
              name="apellido_paterno"
              value={user.apellido_paterno || ""}
              onChange={changeHandler}
            />

            <MDInput
              fullWidth
              label="Apellido Materno"
              name="apellido_materno"
              value={user.apellido_materno || ""}
              onChange={changeHandler}
            />
          </MDBox>

          {/* =========================
              DOCUMENTO
          ========================== */}
          <MDTypography variant="h6">Documento</MDTypography>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="CI"
              name="ci"
              value={user.ci || ""}
              onChange={changeHandler}
            />

            <TextField
              select
              fullWidth
              label="Expedido"
              name="expedido"
              value={user.expedido || ""}
              onChange={changeHandler}
              SelectProps={{ native: true }}
            >
              <option value=""></option>
              <option value="LP">LP</option>
              <option value="CB">CB</option>
              <option value="SC">SC</option>
              <option value="OR">OR</option>
              <option value="PT">PT</option>
              <option value="TJ">TJ</option>
              <option value="CH">CH</option>
              <option value="BE">BE</option>
              <option value="PD">PD</option>
            </TextField>
          </MDBox>

          {/* =========================
              CONTACTO
          ========================== */}
          <MDTypography variant="h6">Contacto</MDTypography>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="Celular"
              name="celular"
              value={user.celular || ""}
              onChange={changeHandler}
            />

            <MDInput
              fullWidth
              label="Teléfono Fijo"
              name="telefono_fijo"
              value={user.telefono_fijo || ""}
              onChange={changeHandler}
            />
          </MDBox>

          {/* =========================
              EXTRA
          ========================== */}
          <MDTypography variant="h6">Información Adicional</MDTypography>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="Username"
              name="username"
              value={user.username || ""}
              onChange={changeHandler}
            />

            <MDInput
              fullWidth
              type="date"
              label="Fecha de Nacimiento"
              name="fecha_cumpleaños"
              value={user.fecha_cumpleaños || ""}
              onChange={changeHandler}
              InputLabelProps={{ shrink: true }}
            />
          </MDBox>

          {/* =========================
              PASSWORD
          ========================== */}
          <MDTypography variant="h6">Seguridad</MDTypography>

          <MDBox display="flex" gap={2}>
            <MDInput
              fullWidth
              label="Nueva Contraseña"
              type={showPassword ? "text" : "password"}
              name="newPassword"
              value={user.newPassword}
              onChange={changeHandler}
              error={errors.newPassError}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePassword}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <MDInput
              fullWidth
              label="Confirmar Contraseña"
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={user.confirmPassword}
              onChange={changeHandler}
              error={errors.confirmPassError}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleConfirmPassword}>
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </MDBox>

          {/* =========================
              BOTÓN
          ========================== */}
          <MDBox display="flex" justifyContent="flex-end" mt={3}>
            <MDButton variant="gradient" color="success" type="submit">
              Guardar cambios
            </MDButton>
          </MDBox>

        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
};

export default UserProfile;
